<template>
    <div id="addTax" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{title}}</div>
                    <router-link class="btn btn-secondary pull-right" href="javascript:void(0)" v-bind:to="'/tax/list'" >
                        <i class="fp-back"> </i> Back
                    </router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content charge-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="taxForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="tax_name">Tax Name :</label>                                        
                                        <input :readonly="editCharge == 1" type="text" class="form-control" v-model="tax_name" id="tax_name" name="tax_name">
                                        <div class="field-error">{{tax_name_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code :</label>
                                        <input type="text" class="form-control" v-model="code" id="code" name="code">
                                        <div class="field-error">{{code_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="percentage">Percentage :</label>
                                        <input type="number" class="form-control" v-model="percentage" id="percentage" name="percentage">
                                        <div class="field-error">{{percentage_msg}}</div> 
                                    </div>
                                    <div class="col form-group">
                                        <div class="charge-type-label">
                                        <label class="control-label require" for="state">State :</label>
                                            <v-select v-model="state" class="custom-vselect" placeholder="Select State"
                                                        id="state" label="text" :options="stateArr"></v-select>
                                            <div class="field-error">{{state_msg}}</div>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <div class="charge-type-label">
                                        <label class="control-label require" for="gl_account">Gl Account Code :</label>
                                            <v-select v-model="gl_account_id" class="custom-vselect" placeholder="Select GL Account Code"
                                                        id="gl_account" label="text" :options="glAccountArr"></v-select>
                                            <div class="field-error">{{gl_account_msg}}</div>
                                        </div>
                                    </div>
                                </div>
                                <ul v-if="formerrors.length">
                                    <li v-for = "formerror in formerrors" :key="formerror.id" v-bind:class="msgClass" >{{formerror}}</li>
                                </ul>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createTaxBtn" class="btn btn-primary" v-on:click.prevent="AddTax('')" >
                                        <i class="fp-save"> </i> Save
                                    </button>
                                    <button id="cancelTaxBtn" class="btn btn-tertiary" v-on:click.prevent="listtax()" >
                                        <i class="fp-close"> </i> Cancel
                                    </button>    
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";

    import {commonMixins} from '../../mixins/commonMixins';
    import {contractMixins} from '../../mixins/contractMixins';
    
    

    export default {
        name: "addTax",
        metaInfo() {
            return {title: (this.$route.params.id > 0)? "Update Tax | FleetPro Application" : "Create Tax | FleetPro Application"}
        },
        mixins:[commonMixins, contractMixins],
        data: () => ({
            editTax:false,
            title:"Add Tax",
            formerrors: [],
            Registertaxbtn:"Add",
            cancelbtn:false,
            msgClass: "",
            tax_name:"",
            code:"",
            percentage:"",
            state:null,
            gl_account_id:null,
            tax_name_msg:"",
            code_msg:"",
            percentage_msg:"",
            state_msg:"",
            gl_account_msg:"",
            stateArr:[],
            glAccountArr:[],
            add_tax_id:0,
            permissions:[],
            cantAccessPage:"",
            loading:false,
            section_update:false,
            moduleArr:[],
            module_id:'',
            module_error_msg:'',
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'add_charges') {
                        self.cantAccessPage = true;
                    }

                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        mounted: function() {

            var self = this;

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3])
            {
                this.add_tax_id = segments[3];
            }


            if(this.$route.query.token == 'list'){

                self.cancelbtn = true;
            }

            self.loadFieldData(['gl_account']);

            if ( this.add_tax_id != 0 ) {

                //change text of button
                setTimeout(function(){
                    $("#createTaxBtn").text("Update");
                },1000);

                this.title = "Update Charge";
                self.editCharge = true;

                //get contact object
                $.ajax({
                    url: process.env.ROOT_API +"/get_tax?id="+self.add_tax_id,
                    type: "GET",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            //console.log(data.content);
                            self.tax_name = data.content.name;
                            self.code = data.content.code;
                            self.percentage = data.content.percentage;
                            self.state = {value:data.content.state_id,text:data.content.state_name};
                            self.gl_account_id = {value:data.content.gl_account_id,text:data.content.gl_account_code};
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,false,'get-charge-data-by-id')
                    }
                });
            } else {
                setTimeout(function(){
                    $("#createTaxBtn").text("Save");
                },500);
            }

            self.getModules();
            self.getPermissions();

            self.getStates();
            // self.getGLAccounts();

        },
        methods:{

            AddTax: function(flag) {

                var self = this;

                this.tax_name = $("#tax_name").val();
                this.code = $("#code").val();
                this.percentage = $("#percentage").val();
                // this.state = $("#state").val();
                // this.gl_account_id = $("#gl_account_id").val();
                //   var formerrors_msg = "";
                this.formerrors = [];
                self.tax_name_msg = "";
                self.code_msg = "";
                self.percentage_msg = "";
                self.state_msg = "";
                self.gl_account_msg = "";
                self.module_error_msg = "";


                if (!this.tax_name) {
                    self.tax_name_msg = "Tax Name is Required.";
                }
                if (!this.code) {
                    self.code_msg = "Tax Code is Required.";
                }

                if (!this.percentage) {
                    self.percentage_msg = "Percentage is Required.";
                }

                if (!this.state.value) {
                    self.state_msg = "State is Required.";
                }
                if (!this.gl_account_id.value) {
                    self.gl_account_msg = "Gl Account is Required.";
                }
                if (self.tax_name_msg == "" && self.code_msg == ""
                    && self.percentage_msg =="" && self.state_msg == "" && self.gl_account_msg == "" ) {

                    var fields = $("#taxForm").serializeArray();
                    fields.push({name: 'state', value: self.state.value});
                    fields.push({name: 'gl_account', value: self.gl_account_id.value});
                    if(self.add_tax_id != 0){
                        fields.push({name: 'id', value: self.add_tax_id });
                    } 

                    $("#createTaxBtn").prop("disabled",true);
                    $("#cancelTaxBtn").prop("disabled",true);

                    $("#createTaxBtn").text("Processing...");

                    $.ajax({
                        url: process.env.ROOT_API + "/add_charge_tax",
                        type: "POST",
                        crossDomain: true,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data: fields,
                        success: function(data) {
                            if(self.add_tax_id == 0){
                                $("#createTaxBtn").text("Save");
                            } else {
                                $("#createTaxBtn").text("Update");
                            }

                            $("#createTaxBtn").prop("disabled",false);
                            $("#cancelTaxBtn").prop("disabled",false);

                            if (data.status == "success") {
                                self.formerrors.push(data.message);
                                self.tax_name = "";
                                self.code = "";
                                self.percentage = "";
                                self.state = null;
                                self.gl_account_id = null;

                                self.msgClass = "success";
                            } else if (data.status == "error") {
                                //add errors in formerror array
                                for(var i=0; i<data.content.length; i++) {
                                    self.formerrors.push(data.content[i]);
                                }

                                self.msgClass = "error";
                            }
                        },
                        error: function(jqXHR, exception) {
                            $("#createTaxBtn").prop("disabled",false);
                            $("#cancelTaxBtn").prop("disabled",false);

                            self.generateStatusCodeMessage(jqXHR,false,'add-tax-data')
                        }
                    });
                } else {
                    console.log($(".error_style").length);
                    self.msgClass = "error";
                    self.errorValidationFocus();
                   
                }
            },
            listtax:function(){
                var self = this;

                self.$router.push("/tax/list");

            },
            getModules:function(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/get_modules_by_package",
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{
                        flag : 'all'
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.moduleArr = data;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-module-by-package')
                    }
                });
            },
            formatString(data){
                var self = this;
                var value = data.replace(/_/g," ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },

            getStates:function(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/get_states",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.stateArr = data;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-module-by-package')
                    }
                })
            }

        }

    }
</script>



// WEBPACK FOOTER //
// src/components/tax/TaxCreate.vue